<template>
  <div>
    <associar-equipe-add-new
      v-model="isAddNewEquipeSidebarActive"
      @refetch-data="getFilaEquipes"
    />
    <contadores
      :total="contadores.total"
      :ativos="contadores.ativos"
      :inativos="contadores.inativos"
      @alterarFiltro="atualizarFiltro"
    />

    <v-card
      flat
      class="pa-3 mt-2"
    >
      <v-card class="d-flex justify-space-between">
        <v-card-title>Equipes</v-card-title>
        <v-btn
          v-if="!acessoPost"
          color="primary"
          class=" ma-3"
          disabled
        >
          <span>Adicionar</span>
        </v-btn>
        <v-btn
          v-else
          color="primary"
          class=" ma-3"
          @click="isAddNewEquipeSidebarActive = !isAddNewEquipeSidebarActive"
        >
          <span>Adicionar</span>
        </v-btn>
      </v-card>
      <div style="min-height: 4px">
        <v-progress-linear
          v-if="loading"
          indeterminate
          @refetch-data="getFilaEquipes"
        ></v-progress-linear>
      </div>
      <table-associacao-fila-equipe
        :items="filaEquipes"
        :acesso-disable="acessoDisable"
        @refetch-data="getFilaEquipes"
      />
    </v-card>
  </div>
</template>

<script>
import { ref, onMounted } from '@vue/composition-api'
import { mapState } from 'pinia'
import AssociarEquipeAddNew from './AssociarEquipeAddNew.vue'
import TableAssociacaoFilaEquipe from './TableAssociacaoFilaEquipe.vue'
import Contadores from '@/components/contadores/Contadores.vue'
import router from '@/router'
import useAuthStore from '@/store/auth'
import FilaService from '@/services/modules/FilaService'

export default {
  components: {
    TableAssociacaoFilaEquipe,
    AssociarEquipeAddNew,
    Contadores,
  },
  props: {
    ativo: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      idPost: 2003,
      acessoPost: true,
      idDisable: 2005,
      acessoDisable: true,
    }
  },

  computed: {
    ...mapState(useAuthStore, ['funcionalidades']),
  },

  mounted() {
    // this.permissoes()
  },

  methods: {
    permissoes() {
      if (!this.funcionalidades.includes(this.idPost)) {
        this.acessoPost = false
      }
      if (!this.funcionalidades.includes(this.idDisable)) {
        this.acessoDisable = false
      }
    },
  },

  setup() {
    const filaEquipesTodos = ref([])
    const filaEquipes = ref([])
    const filtroStatus = ref('true')
    const contadores = ref({ total: 0, ativos: 0, inativos: 0 })

    function aplicarFiltro() {
      contadores.value.total = filaEquipesTodos.value.length
      contadores.value.ativos = filaEquipesTodos.value.filter(it => it.ativa).length
      contadores.value.inativos = filaEquipesTodos.value.filter(it => !it.ativa).length

      filaEquipes.value = filtroStatus.value
        ? filaEquipesTodos.value.filter(it => it.ativa.toString() === filtroStatus.value)
        : filaEquipesTodos.value
    }

    const getFilaEquipes = async () => {
      filaEquipesTodos.value = await FilaService.getFilaEquipes(router.currentRoute.params.id)
      aplicarFiltro()
    }
    onMounted(getFilaEquipes)

    function atualizarFiltro(item) {
      filtroStatus.value = item
      aplicarFiltro()
    }

    const loading = ref(false)
    const isAddNewEquipeSidebarActive = ref(false)

    return {
      filaEquipes,
      contadores,
      atualizarFiltro,
      getFilaEquipes,
      loading,
      isAddNewEquipeSidebarActive,
    }
  },
}
</script>
